<app-user-managment-table [data]="_tableData"
                          [reload]="reloadStatus"
                          [settings]="_tableSettings"
                          (updateUser)="onUpdateUser($event)"></app-user-managment-table>

<app-modal [settings]="_modalSettings"
           (change)="refresh($event)"
           [user]="user"
           [validSettings]="validSettings"></app-modal>
